export default __webpack_public_path__ + "static/media/video-session.4365a3e3.svg";